module.exports = __webpack_public_path__ + "static/media/guide_2.a33d0abe.gif";